// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b9acf11e","453":"d67644d7","732":"63537983","977":"d15faeb6"}[chunkId] + ".chunk.js";
};